import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import CaptchaCanvas from "../../../components/CaptchaCanvas";

const ForgotPasswordModal = ({ show, onClose }) => {
  const [email, setEmail] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSendSuccess, setShowSendSuccess] = useState(false);
  const [showSendFailed, setShowSendFailed] = useState(false);

  useEffect(() => {
    if (show) generateCaptcha();
  }, [show]);

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    const text = Array.from({ length: 5 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
    setCaptchaText(text);
    setCaptchaInput("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("🚀 Submit form triggered");

    if (captchaInput.toUpperCase() !== captchaText.toUpperCase()) {
      setShowSendFailed(true);
      generateCaptcha();
      return;
    }

    setIsSubmitting(true);
    try {
      console.log("📡 Sending request to backend...");
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL_REGISTER}/forgot-password`,
        { email }
      );
      console.log("✅ Response:", res.data);

      setShowSendSuccess(true);
      setTimeout(() => {
        setShowSendSuccess(false);
        onClose();
        window.location.reload();
      }, 2000);
    } catch (err) {
      console.error("❌ Error Axios:", err);
      setShowSendFailed(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Lupa Password?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              className="form-control"
              placeholder="Masukkan email Anda"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <br />

            <div className="mb-2">
              <CaptchaCanvas text={captchaText} />
              <div className="d-flex mt-2">
                <input
                  type="text"
                  className="form-control me-2"
                  placeholder="Ketik ulang teks di atas"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                  required
                />
                <Button variant="secondary" onClick={generateCaptcha}>🔁</Button>
              </div>
            </div>

            <Button type="submit" variant="primary" disabled={isSubmitting}>
              {isSubmitting ? "Mengirim..." : "Kirim Link Reset"}
            </Button>
          </form>
        </Modal.Body>
      </Modal>

      {showSendSuccess && (
        <SweetAlert
          success
          title="Berhasil"
          onConfirm={() => setShowSendSuccess(false)}
          btnSize="sm"
          timeout={10000}
        >
          Link reset telah dikirim ke email Anda.
        </SweetAlert>
      )}
      {showSendFailed && (
        <SweetAlert
          danger
          title="Gagal"
          onConfirm={() => setShowSendFailed(false)}
          btnSize="sm"
          timeout={4000}
        >
          Gagal mengirim link. Periksa email atau captcha Anda.
        </SweetAlert>
      )}
    </>
  );
};

export default ForgotPasswordModal;
